import Icon from '../components/Icon.vue'

Icon.register({
  headphones: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 32c141.5 0 256 114.5 256 256v48c0 10.9-7.9 23.7-17.7 28.6l-14.4 7.2c-2 60.1-51.3 108.2-111.9 108.2h-24c-13.3 0-24-10.7-24-24v-176c0-13.3 10.7-24 24-24h24c31.3 0 59.7 12.9 80 33.6v-1.6c0-105.9-86.1-192-192-192s-192 86.1-192 192v1.6c20.3-20.7 48.7-33.6 80-33.6h24c13.3 0 24 10.7 24 24v176c0 13.3-10.7 24-24 24h-24c-60.6 0-109.9-48.1-111.9-108.2l-14.4-7.2c-9.8-4.9-17.7-17.7-17.7-28.6v0-48c0-141.5 114.5-256 256-256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/headphones.js
// module id = null
// module chunks = 